import classNames from "classnames";

export function Skeleton({ className }: { className?: string }) {
  return <div className={classNames("animate-pulse rounded-sm bg-gray-200", className)} />;
}
